"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmpty = void 0;
const isEmpty = obj => {
  if (obj == null) return true; // Check for null or undefined

  if ([Object, Array].includes(obj.constructor)) {
    return !Object.entries(obj).length;
  }
  return false;
};
exports.isEmpty = isEmpty;